import React from "react";
import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1300, //
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    zIndex: 1301, // ✅ Ensure paper is above backdrop
    position: "relative", // ✅ Add position relative
  },
}));

const OBJECT_LABELS = {
  mobile_phone: "a mobile phone",
  "cell phone": "a mobile phone",
  headphones: "headphones",
  neckband: "a neckband earphone",
};

const describeObjects = (objects) => {
  const names = [...new Set((objects || []).map((o) => OBJECT_LABELS[o] || String(o).replace(/_/g, " ")))];
  if (names.length === 0) return null;
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};

export default function ObjectDetectionModal({ onConfirm, open, isMongoUpdated, objects }) {
  const classes = useStyles();
  const detected = describeObjects(objects);

  return (
    <div>
      <Modal
        open={open}
        onClose={onConfirm}
        disableEnforceFocus={true}
        aria-labelledby="object-detection-modal-title"
        aria-describedby="object-detection-modal-description"
        className={classes.modal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // ✅ Explicit backdrop color
              zIndex: 1300, // ✅ Backdrop z-index
            }
          },
        }}
        sx={{
          zIndex: 1300, // ✅ Modal z-index
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <h3
              id="object-detection-modal-title"
              style={{ color: "#6f2981", marginBottom: "30px", textAlign: "center" }}
            >
              {detected ? "Prohibited Object Detected" : "Background Check"}
            </h3>
            <p id="object-detection-modal-description">
              {detected ? `We detected ${detected} in your camera view.` : "Objects detected in the background."}
              {isMongoUpdated ? (
                <>
                  <br />
                  {detected
                    ? "Please remove it from your surroundings before continuing the test."
                    : "Please clear the area or move to a clean space while the test."}
                </>
              ) : (
                <>
                  <br />
                  Please ensure a clean and clear background for the best experience.
                </>
              )}
            </p>
            {!isMongoUpdated && (
              <p style={{ textAlign: "center", marginBottom: "10px" }}>Saving your responses...</p>
            )}
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              {/* The OK button must always be reachable - if the background violation
                  save (isMongoUpdated) never succeeds (exhausted retries on a bad
                  connection), this used to hide the button entirely with no way to
                  dismiss the modal short of reloading the page. */}
              <button
                className="btn btn-blue"
                style={{ borderRadius: "10px" }}
                onClick={onConfirm}
              >
                Ok
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
